// extracted by mini-css-extract-plugin
export var menuItem = "y_tY d_fZ d_bz d_bD d_bP d_bf";
export var menuItemSub = "y_tZ d_Z d_bz d_bP";
export var menuMainLink = "y_t0 d_f0 d_dB";
export var menuLink = "y_t1 d_f0 d_dB";
export var icon = "y_p9 d_bC d_bP";
export var divider = "y_t2 d_bC d_bP";
export var sublinks = "y_t3";
export var link = "y_mC";
export var Link = "y_sN w_sN w_r6 w_sr";